import UISignals from "../controllers/UISignals";

export default class UIModel {
    constructor() {
        this._indexAutoStopBalanceLower = -1
        this._indexAutoStopBalanceHigher = -1

        this._scoreWin = 0
        this._balance = 0
        this._amountLeft = 0
        this._freeSpinTotalCount = 0
        this._showSettings = false
    }

    set initData(value) {
        this._initData = value
        this.setAutospinValues = value.setAutospinValues
        this.autospinValuesIndex = 0
        this.resizeData = null
        this.whenFreespins = true
        this.maxwin = value.maxwin
        this.rtp = value.rtp
        this.rtpBonusBuy = value.rtpBonusBuy
        this.autospinList = value.autospinList
        this.toFixed = this._initData.toFixed

        this.paytable = this._initData.paytable
        this.currency = this._initData.currency
        this.setPossibleBets = this._initData.possibleBets
        this.betsValues = this._initData.possibleBetsValues
        this.currentBetIndex = value.currentBetIndex
        this.buyFreebet = value.buyFreebet
        this.currentBuyFreebetIndex = -1
        this.historyUrl = value.historyUrl
        this._freeSpinTotalCount = this._initData.freeSpinTotalCount
        this._amountLeft = this._initData.amountLeft
        this._isAutospinShow = this._initData.isAutospinShow
    }

    get initData() {
        return this._initData
    }

    set freeSpinLeft(value) {
        this._freeSpinLeft = value
    }

    get freeSpinLeft() {
        return this._freeSpinLeft
    }

    set freeSpinTotalCount(value) {
        this._freeSpinTotalCount = value
    }

    get freeSpinTotalCount() {
        return this._freeSpinTotalCount
    }

    get amountLeft() {
        return this._amountLeft
    }

    // TODO: for tests
    set isAutospin(value) {
        this._isAutospin = value
    }

    get isAutospin() {
        return this._isAutospin
    }

    //
    // set settingsSingleWin(value) {
    //     this._settingsSingleWin = value
    //     document.dispatchEvent(new CustomEvent('tap', {
    //         detail: {
    //             name: 'singleWin',
    //             value: this.initData.autoSingleWinValues[value]
    //         }
    //     }))
    //
    // }
    //
    // get settingsSingleWin() {
    //     return this._settingsSingleWin
    // }


    set autoplaySettingsData(autoplayData) {
        this._autoplaySettingsData = autoplayData
    }

    get autoplaySettingsData() {
        const data = this._autoplaySettingsData
        const autoplayData = {
            autoStopCount: -1, autoStopBalanceLower: -1, autoStopBalanceHigher: -1, autoStopMoneyExceed: -1
        }
        if (data.indexAutoStopCount !== -1) {
            autoplayData.autoStopCount = this.autospinList[data.indexAutoStopCount]
        }
        if (data.indexAutoStopBalanceLower !== -1) {
            autoplayData.autoStopBalanceLower = this.autoStopBalanceLowerValues[data.indexAutoStopBalanceLower]
        }
        if (data.indexAutoStopBalanceHigher !== -1) {
            autoplayData.autoStopBalanceHigher = this.autoStopBalanceHigherValues[data.indexAutoStopBalanceHigher]
        }
        if (data.indexAutoStopMoneyExceed !== -1) {
            autoplayData.autoStopMoneyExceed = this.autoStopMoneyExceedValues[data.indexAutoStopMoneyExceed]
        }
        return autoplayData
    }


    set indexAutoStopBalanceLower(value) {
        this._indexAutoStopBalanceLower = value
        document.dispatchEvent(new CustomEvent('tap', {
            detail: {
                name: 'autoStopBalance',
                value: this.initData.autoStopBalanceLowerValues[value]
            }
        }))
    }

    get indexAutoStopBalanceLowerValues() {
        return this._indexAutoStopBalanceLower
    }

    set indexAutoStopBalanceHigher(value) {
        this._indexAutoStopBalanceHigher = value
        document.dispatchEvent(new CustomEvent('tap', {
            detail: {
                name: 'autoStopBalance',
                value: this.initData.autoStopBalanceHigherValues[value]
            }
        }))
    }

    get indexAutoStopBalanceHigher() {
        return this._indexAutoStopBalanceHigher
    }


    get autoStopBalanceLowerValues() {
        return this.initData.autoStopBalanceLowerValues
    }

    get autoStopBalanceHigherValues() {
        return this.initData.autoStopBalanceHigherValues
    }

    get autoStopMoneyExceedValues() {
        return this.initData.autoStopMoneyExceedValues
    }

    set whenFreespins(value) {
        this._whenFreespins = value
    }

    get whenFreespins() {
        return this._whenFreespins
    }

    set setAutospinValues(value) {
        this._setAutospinValues = value
    }

    get setAutospinValues() {
        return this._setAutospinValues
    }

    set autospinValuesIndex(value) {
        this._autospinValuesIndex = value
    }

    get autospinValuesIndex() {
        return this._autospinValuesIndex
    }

    set currentBetIndex(value) {
        this._currentBetIndex = value

        // Send to Paytable && SEventM
        UISignals.currentBetIndexHasChanged.dispatch(this._currentBetIndex)
    }

    get currentBetIndex() {
        return this._currentBetIndex
    }

    set locale(value) {
        this._locale = value
    }

    get locale() {
        return this._locale
    }

    set rtp(value) {
        this._rtp = value
    }

    get rtp() {
        return this._rtp
    }

    set maxwin(value) {
        this._maxwin = value
    }

    get maxwin() {
        return this._maxwin
    }

    betDecrease() {
        if (this.currentBetIndex > 0) {
            this.currentBetIndex--
        }
    }

    betIncrease() {
        if (this.currentBetIndex < this.setPossibleBets.length - 1) {
            this.currentBetIndex++
        }
    }

    set buyFreebet(value) {
        this._buyFreebet = value
    }

    get buyFreebet() {
        return this._buyFreebet
    }

    get buyBtnHide() {
        return this._buyFreebet.length === 0
    }

    get currentBuyFreebetIndex() {
        return this._currentBuyFreebetIndex
    }

    set currentBuyFreebetIndex(index) {
        this._currentBuyFreebetIndex = index
        UISignals.currentBuyFreebetChanged.dispatch(this._currentBuyFreebetIndex)
        // document.dispatchEvent(new CustomEvent('tap', {
        //     detail: {
        //         name: 'betChanged',
        //         value: this._currentBuyFreebetIndex
        //     }
        // }))
    }

    set scoreWin(value) {
        this._scoreWin = value
    }

    get scoreWin() {
        return this._scoreWin
    }

    set balance(value) {
        this._balance = value
    }

    get balance() {
        return this._balance
    }


    set showSettings(value) {
        this._showSettings = value
    }

    get showSettings() {
        return this._showSettings
    }

    get isAutospinShow(){
        return this._isAutospinShow
    }

}
